import { createConnectTransport } from "@connectrpc/connect-web";

/** Calls the api's Connect endpoints on the same origin. */
export const transport = createConnectTransport({ baseUrl: "/rpc" });
